import createNamedContext from "./createNameContext";

const historyContext = /*#__PURE__*/ createNamedContext("Router-History");
export default historyContext;



// WEBPACK FOOTER //
// ../modules/HistoryContext.js